import React, { useCallback, useMemo } from 'react';
import { ComplexValue } from 'app/types-shared';
import { SubscriptionTilesProps } from './types';
import { SubscriptionTile } from './subscription-tile';
import {
  mergeOptions, sortOptions, unSubscribedOptions, activeSubscriptions
} from 'app/area/user-profile/subscriptions/subscriptions-panel/mappers';
import { GroupText } from 'app/area/user-profile/subscriptions/group-text';
import { TileWrapper } from 'app/area/user-profile/subscriptions/subscriptions-panel/subscriptions-container/subscription-tiles/tile-wrapper';
import { SubscriptionStoreValue } from 'app/area/user-profile/subscriptions/types';

export const SubscriptionTiles: React.FC<SubscriptionTilesProps> = (props) => {

  const { componentId, fetching, options = [], valueItems = [],
    subscribedText, locale, translation, onChange } = props;

  if (fetching || ((!valueItems) && !options)) {
    return <div id={componentId} />;
  }

  const changeHandler = useCallback(
    (value: ComplexValue<number>, checked: boolean) => {

      if (checked) {
        onChange([...valueItems, value]);
      } else {
        onChange(valueItems.filter(item => item.value !== value.value));
      }
    }, [valueItems, onChange]);

  const mapSubscriptionTiles = (values: SubscriptionStoreValue[]) =>
    values.map(option =>
      <SubscriptionTile
        key={option.value}
        option={option}
        valueItems={valueItems}
        translation={translation}
        changeHandler={changeHandler} />);

  const mergedOptions = useMemo(() => mergeOptions(options, valueItems), [options, valueItems]);
  const subscribed = activeSubscriptions(sortOptions(valueItems, locale));
  const unsubscribed = activeSubscriptions(unSubscribedOptions(mergedOptions, valueItems));

  return <>
    <TileWrapper>
      {subscribedText && <GroupText>{subscribedText}</GroupText>}
      <div className="row">
        {subscribed.length > 0 ? mapSubscriptionTiles(subscribed)
          : <div className="col-md-12 mt-1 mb-3">
            <p className="no-content mt-2">{translation.no_subscriptions}</p>
          </div>}
      </div>
    </TileWrapper>

    {unsubscribed.length > 0 && <TileWrapper>
      <GroupText>{translation.unsubscribed_text}</GroupText>
      <div className="row">
        {mapSubscriptionTiles(unsubscribed)}
      </div>
    </TileWrapper>}
  </>;
};
